<template>
  <form
    class="form"
    @submit.prevent="onSubmit"
  >
    <div class="input-grp mb-3">
      <label for="areaofexpertise">Area of expertise</label>
      <select
        id="areaofexpertise"
        v-model="searchData.area"
        name="areaofexpertise"
      >
        <option
          value=""
          selected
          disabled
        >
          Please Select (Eg.: Banking Law)
        </option>
        <option
          v-for="area in specializations"
          :key="area.id"
          :value="area.name"
        >
          {{ area.name }}
        </option>
      </select>
    </div>
    <div class="input-grp mb-3">
      <label for="district">District</label>
      <select
        id="district"
        v-model="searchData.city"
        name="district"
      >
        <option
          value=""
          selected
          disabled
        >
          Please Select (Eg.: Kathmandu)
        </option>
        <option
          v-for="city in districts"
          :key="city.id"
          :value="city.city"
        >
          {{ city.city }}
        </option>
      </select>
    </div>
    <div class="input-grp button-container">
      <SubmitButtonComponent
        :is-loading="loading"
        label="Search"
        class="primary-button"
      />
    </div>
  </form>
</template>

<script>
import SubmitButtonComponent from '@/components/ButtonComponent/SubmitButtonComponent.vue'
import {onMounted, computed, reactive} from 'vue'
import {useDistrictStore, useLawyerStore, useSpecializationStore} from '@/store'
import {useRouter} from 'vue-router'
import {toast} from '@/utils/toast'

export default {
  name: 'SearchALawyer',
  components: {
    SubmitButtonComponent,
},

setup() {
    const router = useRouter()
    const specializationStore = useSpecializationStore()
    const districtStore = useDistrictStore()
    const lawyerStore = useLawyerStore()

    const searchData = reactive({
      area: '',
      city: '',
    })

  onMounted(async () => {
      await specializationStore.getAllSpecialization()
      await districtStore.getAllDistricts()
    })
    const specializations = computed(() => specializationStore.allSpecialization)
    const districts = computed(() => districtStore.allDistricts)
    const loading = computed(() => lawyerStore.loading)

    const onSubmit = async () => {
      if (searchData.area === '' && searchData.city === '') {
        return toast.warning('Please Select Area of Expertise or District.')
      }
     await lawyerStore.getAllSearchedLawyers(searchData)
     if (lawyerStore.isSearchSuccess) {
      router.push(`/lawyer-list?city=${searchData.city}&area=${searchData.area}`)
     }
    }

    return {
      specializations,
      districts,
      loading,
      searchData,
      onSubmit,
    }
},
}
</script>

<style scoped>
  .lds-ring-container{
    left: 26rem;
  }
</style>
